import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export type SiteMapWizardDataType = Map<
  string | number,
  {
    pageName: string;
    parent: string | number;
    pagePath: string;
    description: string;
    isCustomPage: boolean;
    keywords: string[];
    pictures: {
      cmsElId: string;
      url: string;
    }[];
    section: {
      name: string;
      variant: number;
    }[];
    areas: {
      cmsElId: string;
      name: string;
      text: string;
    }[];
  }
>;

export default class SiteMapWizardData extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession({
    type: 'Map'
  })
  public siteMap: SiteMapWizardDataType = new Map();

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(formData: { siteMap: SiteMapWizardDataType }) {
    this.siteMap = formData.siteMap;
  }

  getWizardData() {
    return {
      siteMap: this.siteMap
    };
  }

  getSessionKey() {
    return 'SiteMapWizardData';
  }
}
